import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NewOrder from "./pages/NewOrder";
import Orders from "./pages/Orders";
import OrderDetail from "./pages/OrderDetail";
import EditOrder from "./pages/EditOrder";
import UsersPage from "./pages/Users";
import Commissions from "./pages/Commissions";
import CustomerConfirm from "./pages/CustomerConfirm";
import CustomerPortal from "./pages/CustomerPortal";
import Layout from "./components/Layout";
import "./App.css";

const TOAST_OPTIONS = {
  duration: 4000,
};

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster 
          position="top-right" 
          richColors 
          closeButton
          toastOptions={TOAST_OPTIONS}
        />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/confirm/:token" element={<CustomerConfirm />} />
          <Route path="/kunde" element={<CustomerPortal />} />
          
          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="new-order" element={<NewOrder />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/:orderId" element={<OrderDetail />} />
            <Route path="orders/:orderId/edit" element={<EditOrder />} />
            <Route path="users" element={
              <ProtectedRoute adminOnly>
                <UsersPage />
              </ProtectedRoute>
            } />
            <Route path="commissions" element={
              <ProtectedRoute adminOnly>
                <Commissions />
              </ProtectedRoute>
            } />
          </Route>
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
